import styled from "styled-components";
import css from "@styled-system/css";

interface StyledBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode;
}

const StyledBadge = styled.span<StyledBadgeProps>`
  font-size: 13px;
  margin: 0;
  margin-right: 10px;
  padding: 0 10px;
  text-align: center;
  font-weight: bold;
  line-height: 24px;
  border-radius: 4px;
  border: solid 1px;
  ${css({
    marginBottom: [10, 0],
  })}
`;

const SaleType = ({
  saleInformationType,
}: {
  saleInformationType: "Confirmed" | "Scheduled" | "Started";
}) => {
  const textColorsMap = {
    Confirmed: "#609833",
    Scheduled: "#ee9504",
    Started: "white",
  };
  const borderColorsMap = {
    Confirmed: "#609833",
    Scheduled: "#ee9504",
    Started: "#609833",
  };
  const bgColorsMap = {
    Confirmed: "transparent",
    Scheduled: "transparent",
    Started: "#609833",
  };
  const wordMap = {
    Confirmed: "Confirmed",
    Scheduled: "Planned",
    Started: "In Progress",
  };
  return (
    <StyledBadge
      data-testid="sale-type-badge"
      style={{
        color: textColorsMap[saleInformationType] || "black",
        borderColor: borderColorsMap[saleInformationType] || "black",
        background: bgColorsMap[saleInformationType] || "black",
      }}
    >
      {wordMap[saleInformationType]}
    </StyledBadge>
  );
};

export default SaleType;
